module.exports = __webpack_public_path__ + "static/epitome-tartaglia2-banner-89c7b44d505d8ae7c9cecccad1b40ad4.png";